import { useEffect } from 'react';
import '../../utils/assertions.es.js';
import { noop } from '../../utils/functions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';

var useMountEffect = function useMountEffect(effect, cleanup) {
  if (cleanup === void 0) {
    cleanup = noop;
  }

  return useEffect(function () {
    effect();
    return cleanup;
  }, []);
};

export { useMountEffect as default, useMountEffect };